import { http } from './http';
import { api } from './endpoints';
import axios from "axios";

export const productService = {

    async getDetails(id: number | string) {
        return http.get(api.products.details(id)).then(response => response.data);
    },
    async getOtcUrl(id: number | string) {
        return http.get(api.products.otcUrl(id)).then(r => r.data);
    },

    async getPraeparatUrl(productId: number | string, praeparatId: number | string) {
        return http.get(api.products.praeparatUrl(productId, praeparatId)).then(r => r.data);
    },
    
    
    async getExcludedOtcs() {
        return http.get(api.products.excludedOtcs).then(r => r.data);
    },
    
    async getAllOtcCategories() {
        return http.get(api.products.allOtcCategories).then(r => r.data);
    }

};

export type ProductService = typeof productService;